export default __webpack_public_path__ + "static/media/navbar-scheduled-dark.fa5bd9c9.svg";